import React from 'react';
import {Row, Typography} from 'antd';

import {useAppSelector} from '../../../hooks/useStore';
import {RootState} from '../../../store/store';
import {selectAccountMembershipNumber} from '../../../store/slices/userSlice';

import CalendarView from './CalendarView';
import {messageType, showMessages} from '../../../helpers/message';
import {bookingInfo} from '../../../helpers/booking';
import {CarsAvailabilityViewProps, Deployment} from '../../../types/bookingTypes';

import './CarsAvailabilityView.less';
import {titleHeader} from '../../../assets/styles';

const CarsAvailabilityView = ({
                                  deployments,
                                  newBooking,
                                  setNewBooking,
                                  clearNewBooking,
                                  goToBookingSummary,
                                  itemsPerPage = 10000,
                              }: CarsAvailabilityViewProps) => {
    const accountMembershipNumber = useAppSelector(selectAccountMembershipNumber);
    const person = useAppSelector((state: RootState) => state.user.person);

    const [newBookingTitle, setNewBookingTitle] = React.useState(bookingInfo.type.new.displayName);
    const displayMobileMessage = window.innerWidth <= 1024;

    //region Car Availability Helpers

    const populateNewBookingTitle = React.useCallback(() => {
        const title = `${accountMembershipNumber || ''} ${person ? `${person.first_name} ${person.last_name}` : ''}`;
        setNewBookingTitle(title.trim());
    }, [accountMembershipNumber, person, setNewBookingTitle]);

    //endregion

    //region Lifecycle Helpers

    // Functional equivalent of componentDidMount.
    React.useEffect(() => {
        populateNewBookingTitle();

        if (displayMobileMessage) {
            showMessages('Please hold and drag to make a booking.', messageType.info);
        }
    }, [displayMobileMessage, populateNewBookingTitle]);

    //endregion

    const getCurrentDisplayItems = (pageNumber = 1) => {
        let endItemNumber = pageNumber * itemsPerPage;
        let beginItemNumber = endItemNumber - (itemsPerPage - 1);

        if (endItemNumber > deployments.length) endItemNumber = deployments.length;

        const beginItemIndex = beginItemNumber - 1;
        const endItemIndex = endItemNumber - 1;

        let deploymentsToShow: Deployment[] = [];
        for (let i = beginItemIndex; i <= endItemIndex; i++) {
            deploymentsToShow.push(deployments[i]);
        }

        return (
            <>
                <Typography.Title level={3} className="grid-title" style={{...titleHeader}}>
                    Create Booking
                </Typography.Title>
                <Row
                    key="content"
                    justify="space-between"
                    style={{height: "100%"}}
                >
                    <CalendarView
                        deployments={deploymentsToShow}
                        buildBookingData={setNewBooking}
                        clearNewBooking={clearNewBooking}
                        newBooking={newBooking}
                        newBookingTitle={newBookingTitle}
                        goToBookingSummary={goToBookingSummary}
                        itemsPerPage={itemsPerPage}
                    />
                </Row>
            </>
        );
    };

    return (
        <>
            {getCurrentDisplayItems()}
        </>
    );
}

export default CarsAvailabilityView;
